.headerImg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border: none;
  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
}

.container {
  background-color: var(--tuna-palette-background-paper);
  opacity: 0.4;
}
